import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画免费全集目录`}
          title={`${comic.title} 漫画免费全集`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
          loading="lazy"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2 py-0.5 text-[11px] font-medium ${
            comic.status === '连载中'
              ? 'bg-accent-500 text-background-50'
              : 'bg-secondary-600 text-background-50'
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute bottom-2 right-2 rounded-full bg-black/50 px-2 py-0.5 text-[11px] text-background-50">
          {comic.views}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm text-foreground-950">{comic.title}</h3>
        <div className="mt-1 flex items-center justify-between text-xs">
          <span className="text-primary-600">{comic.category}</span>
          <span className="flex items-center gap-0.5 text-accent-600">
            <i className="ri-star-fill" /> {comic.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}